/**
 * Textarea memoizzata con debounce locale
 * @module flyers/components/fields/MemoizedTextArea
 */

import React from "react";
import { Input } from "antd";
import FloatingField from "@shared/components/FloatingField.jsx";

const { TextArea } = Input;

/**
 * Textarea ottimizzata con stato locale e propagazione onBlur
 */
const MemoizedTextArea = React.memo(({ fieldKey, label, value, onChange, disabled, autoSize }) => {
    const [localValue, setLocalValue] = React.useState(value || "");

    React.useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleChange = React.useCallback((event) => {
        setLocalValue(event.target.value);
    }, []);

    const handleBlur = React.useCallback(() => {
        if (localValue !== value) {
            onChange(fieldKey, localValue);
        }
    }, [fieldKey, onChange, value, localValue]);

    return (
        <FloatingField label={label}>
            <TextArea
                placeholder={label}
                autoSize={autoSize}
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />
        </FloatingField>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.value === nextProps.value &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.fieldKey === nextProps.fieldKey
    );
});

MemoizedTextArea.displayName = "MemoizedTextArea";

export default MemoizedTextArea;
